export default __webpack_public_path__ + "static/media/peterpan-logo-disabled.2597dcb8.svg";